import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { DataTable } from './DataTable'
import { YhBox } from '@/components/YhBox'
import { DescriptionColorEnum, IDescription } from '@/components/YhBox/Types'
import useNavModel from '@/model/navModel'
import { globalPrompt } from '@/components/message'
import { YhAuth } from '@/components/auth/YhAuth'
import { useAssetsEntryDetailsModel } from './details/assetsEntryDetailsModel'
import { useAssetsEntryModel } from '../assetsEntryModel'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { PlusOutlined } from '@ant-design/icons'
import { useAssetsGetDetailsModel } from '../../assetsGet/view/details/assetsGetDetailsModel'

export const DataBox = () => {
    const { selectedRowKeys, statistics, exportData,setPrint,printTip} = useAssetsEntryModel()
    const { resetEditCatch,getSDcDetailOne } = useAssetsEntryDetailsModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])
    const {setReturnReceiveId} = useAssetsGetDetailsModel()
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let AssetsEntryEditKey = '2-1-2'
        let isFindNav = findNav(AssetsEntryEditKey)
        if (!isFindNav) {
            addNav(AssetsEntryEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '物资入库跳转详情',
                type: 'warning',
                text: '您还有物资入库详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(AssetsEntryEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }
	//转领取
	const returnReceive =  () => {
		if (selectedRowKeys.length !== 1) {
			globalPrompt('message', { text: '请选择单条数据进行打印标签，点击鼠标右键可一键选中哦！', type: 'warning' })
			return
		}
		globalPrompt('modal', {
			title: '转领取',
			type: 'warning',
			text: '您是否将系单据转领取？',
			okText: '确认',
			onOk:  () => {
				getSDcDetailOne(selectedRowKeys[0]).then((retData)=>{
                    setReturnReceiveId(retData)
                    addNav('2-2-1', { id: '', mode: 'add' })
                })
			},
			cancelText: '取消',
			onCancel: () => {},
		})

		}
    const action = (
        <>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_P_AD}>
        <Button className="mr-5" shape="round" onClick={() => addNav('2-1-1', { id: '', mode: 'add' })} type="primary">
            <PlusOutlined />
            采购
        </Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_P_ED}>
        <Button className="mr-5" type="link" shape="round" onClick={onEdit}>
                更新
        </Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_P_PRINT}>
        <Button className="mr-5" shape="round" type='link' disabled={selectedRowKeys.length !== 1}
                onClick={() => setPrint(true)}>
            打印单据
        </Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_P_EX}>
        <Button className="mr-5" shape="round" type="link" onClick={()=>exportData()}>
            导出
        </Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_P_PRINT_LABEL}>
        <Button className="mr-5" shape="round" type="link" onClick={()=>printTip()} disabled={selectedRowKeys.length !== 1}>
            打印标签
        </Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_P_TRANS_S}>
        <Button className="mr-5" shape="round" type="link" onClick={()=>returnReceive()} disabled={selectedRowKeys.length !== 1}>
            转领取
        </Button>
        </YhAuth>
        <div style={{ fontSize: '17px', fontWeight: 'bolder', float: 'right' }}>
            <span>
                采购数量：<span style={{ color: 'green' }}>{statistics?.totalNum}</span>
            </span>
            <span style={{ marginLeft: '20px' }}>
                采购金额：<span style={{ color: 'red' }}>{statistics?.totalAmount}</span>
            </span>
        </div>
    </>
)

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}
